<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row flex flex-align-center flex-justify-space-between">
          <h2 data-testid="reports-home-heading">{{ 'reports.home.title' | translate }}</h2>
          <app-button variant="filled" (click)="createNew()" *hasPermission="'reports.create'"
            data-testid="new-report-button">
            <app-icon name="plus" />
            {{ 'reports.home.newReport' | translate }}
          </app-button>
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      <p data-testid="reports-home-description">{{ 'reports.home.description' | translate }}</p>
    </app-card-content>
  </app-card>

  <!-- Saved reports -->
  <app-card>
    <app-card-header>
      <app-card-title>
        <h3>{{ 'reports.home.savedReportsTitle' | translate }}</h3>
      </app-card-title>
    </app-card-header>
    <app-card-content>
      @if (reports().length === 0) {
      <div class="empty-state flex flex-column flex-align-center gap-sm p-lg" data-testid="saved-reports-empty">
        <app-icon name="chart-column" [size]="32" />
        <p>{{ 'reports.home.savedReportsEmpty' | translate }}</p>
      </div>
      } @else {
      <ul class="report-list" data-testid="saved-reports-list">
        @for (report of reports(); track report.id) {
        <li class="report-item flex flex-align-center gap-md" [attr.data-testid]="'report-item-' + report.id">
          <div class="report-info flex-grow">
            <span class="report-name">{{ report.name }}</span>
            @if (report.visibility === 'org_shared') {
            <span class="report-badge" data-testid="shared-badge">
              <app-icon name="users" [size]="12" />
              {{ 'reports.home.sharedBadge' | translate }}
            </span>
            }
          </div>

          @if (confirmingDeleteId() === report.id) {
          <div class="confirm-delete flex flex-align-center gap-sm" [attr.data-testid]="'confirm-delete-' + report.id">
            <span>{{ 'reports.home.confirmDelete' | translate }}</span>
            <app-button variant="filled" color="danger" (click)="confirmDelete(report)"
              [attr.data-testid]="'confirm-delete-yes-' + report.id">
              {{ 'reports.home.confirmDeleteYes' | translate }}
            </app-button>
            <app-button variant="text" (click)="cancelDelete()"
              [attr.data-testid]="'confirm-delete-no-' + report.id">
              {{ 'reports.home.confirmDeleteNo' | translate }}
            </app-button>
          </div>
          } @else {
          <div class="report-actions flex flex-align-center gap-sm">
            <app-button variant="filled" (click)="run(report)" [attr.data-testid]="'run-report-' + report.id">
              <app-icon name="play" />
              {{ 'reports.home.run' | translate }}
            </app-button>

            @if (canManage(report)) {
            <app-button variant="outlined" (click)="edit(report)" [attr.data-testid]="'edit-report-' + report.id">
              <app-icon name="settings" />
              {{ 'reports.home.edit' | translate }}
            </app-button>

            @if (canShare()) {
            <app-button variant="outlined" (click)="toggleShare(report)"
              [attr.data-testid]="'share-report-' + report.id">
              <app-icon [name]="report.visibility === 'org_shared' ? 'lock' : 'users'" />
              {{ (report.visibility === 'org_shared' ? 'reports.home.unshare' : 'reports.home.share') | translate }}
            </app-button>
            }

            <app-button variant="icon" color="danger" (click)="requestDelete(report)"
              [attr.data-testid]="'delete-report-' + report.id">
              <app-icon name="trash" />
            </app-button>
            }
          </div>
          }
        </li>
        }
      </ul>
      }
    </app-card-content>
  </app-card>
</div>
